import { trackModalImpression } from '../../analytics/event-tracking/trackModalImpression';
import { MOBILE_MAX } from '@property.com.au/ui-kit';

export const useTrackBeforeYouBuyModalEvent = () => {
  return (inPageSource: string) => {
    trackModalImpression({
      modal_name: 'byb_modal',
      screen_name: 'property_page',
      modal_is_fullscreen: window.innerWidth <= MOBILE_MAX + 1,
      in_page_source: inPageSource,
    });
  };
};
